export enum ManualLanguage {
    de, en, fr, it, pl, zh
}
